// extracted by mini-css-extract-plugin
export var smallSpinner = "_qx-0";